import React from 'react'
import { TextBox } from 'components/atoms'
import { DetailLinkList } from 'components/molecules'
import * as Styled from './Cooperations.styles'
import { CooperationList } from './partials'
import { entryPointId } from 'settings/app/constants'
import PropTypes from 'prop-types'

const Cooperations = ({ contact, cooperations }) => (
  <>
    {contact && <TextBox title={ contact.title }>{contact.content}</TextBox>}
    {cooperations.map((cooperation, indexCooperation) => (
      <TextBox
        key={ `cooperation-${ indexCooperation }` }
        title={ cooperation.headline }>
        {cooperation.description && <p>{cooperation.description}</p>}
        {cooperation.isAccordion ? (
          <Styled.Cooperation>
            {cooperation.list.map((listItem, indexListItem) => (
              <CooperationList
                key={ `cooperation-list-${ indexListItem }` }
                cooperation={ listItem }
                open={ !!cooperation.open }
                linkTyp={
                  listItem.linkTyp ? cooperation.linkTyp : entryPointId.DOCTORS
                }
              />
            ))}
          </Styled.Cooperation>
        ) : (
          <DetailLinkList
            key={ indexCooperation }
            items={ cooperation.list }
            linkTyp={
              cooperation.linkTyp ? cooperation.linkTyp : entryPointId.DOCTORS
            }
          />
        )}

        {cooperation?.notice && <p>{cooperation.notice}</p>}
      </TextBox>
    ))}
  </>
)

Cooperations.propTypes = {
  contact: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
  cooperations: PropTypes.arrayOf(
    PropTypes.shape({
      isAccordion: PropTypes.bool,
      linkTyp: PropTypes.string,
      headline: PropTypes.string,
      description: PropTypes.string,
      list: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          open: PropTypes.bool,
          doctors: PropTypes.arrayOf(
            PropTypes.shape({
              id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              name: PropTypes.string,
              label: PropTypes.string,
              teamLeading: PropTypes.bool,
            })
          ),
        })
      ),
      notice: PropTypes.string,
    })
  ),
}

export default Cooperations
